import { REVEALED } from "./password-reveal-event"
import { documentReady } from "./utils/dom"

const revealPasswordTimeouts = []

function showPassword(el, revealed) {
  const inputField = el.querySelector("input")
  const iconElement = el.querySelector("i")

  inputField.type = revealed ? "text" : "password"
  iconElement.classList.toggle("glyphicon-eye-close", revealed)
  iconElement.classList.toggle("glyphicon-eye-open", !revealed)
}

function revealPassword(el) {
  const inputField = el.querySelector("input")
  const fieldId = inputField.getAttribute("id")
  const revealing = inputField.type === "password"

  showPassword(el, revealing)
  clearTimeout(revealPasswordTimeouts[fieldId])

  if (revealing) {
    revealPasswordTimeouts[fieldId] = setTimeout(() => showPassword(el, false), 3000)
    el.dispatchEvent(new CustomEvent(REVEALED, { bubbles: true }))
  }
}

documentReady(() => {
  const containerElements = document.querySelectorAll(".password-with-reveal")

  containerElements.forEach((containerElement) => {
    const iconElement = containerElement.querySelector("i")
    if (iconElement) {
      iconElement.addEventListener("click", () => revealPassword(containerElement))
    }
  })
})
